export default {
  pt: {
    continueText: "Continuar",
  },
  en: {
    continueText: "Continue",
  },
}; 